<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/products-download/products-download']">
    <span translate>COMMONS.PRODUCTS</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>{{ productDto.Description }}</span>
</div>
<tb-header specificTitle="COMMONS.DOWNLOAD"></tb-header>


<div class="contentGlobal" style="text-align: center" *ngIf="!isLoading">

  <!--<button mat-button color="primary" (click)="download()">Download</button>-->

  <div class="primaryrelease-container" style="width:100%" *ngIf="principalProductRelease">
    <div class="release-card">
      <ms-product-version-card [isPlatinumPartner]="this.productDownloadService?.isPlatinumPartner" [downloadable]="true" [productRelease]="principalProductRelease" [family]="productDto.Family"  [isLargeVersionCard]="true"></ms-product-version-card>
    </div>
    <div class="releases-table">
      <ms-product-releases-table (openedRelease)="ngOnInit()" [isPlatinumPartner]="this.productDownloadService?.isPlatinumPartner" [family]="productDto.Family" [productCode]="productDto.ProductCode"></ms-product-releases-table>
    </div>
  </div>

  <div class="primaryrelease-container" style="margin-top: 5.5rem " *ngIf="!isLoading">
    <h1 style="text-align:left"><span translate>COMMONS.VIEW_BUGS_RELEASE_NOTES</span></h1>
  </div>

  <div class="primaryrelease-container" *ngIf="!isLoading && productDto">
    <div class="release-card" style="width:48%">
      <mat-card class="fuse-card-grid" style="margin: 0 !important; width: 100%;">
        <mat-card-header>
            <mat-card-title translate>Bugs report</mat-card-title>
        </mat-card-header>
        <ms-reports [productDto]="productDto" [reportType]="'BUGS'"></ms-reports>
      </mat-card>
    </div>
    <div class="release-card" style="width:48%">
      <mat-card class="fuse-card-grid" style="margin: 0 !important; width: 100%;">
        <mat-card-header>
            <mat-card-title translate>Release notes</mat-card-title>
        </mat-card-header>
        <ms-reports [productDto]="productDto" [reportType]="'IMPROVEMENTS'"></ms-reports>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>
